<template>
  <div class="btn-pill-wrapper">
    <div v-has-feature="'Admin'">
        <btn-pill
            class="margin-right-l"
            btn-type="secondary"
            btn-size="s"
            @click="goToTaxonomy()">
          <font-awesome-icon :icon="icon.tags"/>
          {{ $t('variables.taxonomy') }}
        </btn-pill>
        <btn-pill
            btn-type="secondary"
            btn-size="s"
            @click="goToCategoricalVariables()">
          <font-awesome-icon :icon="icon.list"/>
          {{ $t('variableManagement.categoricalVariables') }}
        </btn-pill>
    </div>
  </div>
</template>
<script>
import BtnPill from '@/components/shared/buttons/BtnPill';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faList, faTags} from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'GoToTagsAndCategorical',
  components: {BtnPill, FontAwesomeIcon},
  props: {
    origin: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      icon: {
        tags: faTags,
        list: faList
      }
    };
  },
  methods: {
    goToTaxonomy () {
      this.$router.push({name: 'VariableTagTree', query: {origin: 'VariableManagement'}});
    },
    goToCategoricalVariables () {
      this.$router.push({name: 'VariableCategoryList', query: {origin: 'VariableManagement'}});
    }
  }
};
</script>
<style lang="scss" scoped>
    @import "src/stylesheets/variables";

    .btn-pill-wrapper {
      display: flex;
      align-items: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/variable/GoToTagsAndCategorical.vue